import React, { useId, useMemo } from 'react';

export type SchemaSelectionComponentItem<T> = {
  optionKey: string;
  optionLabel: string;
  optionValue: T;
};

export const SchemaSelectionComponent = <T,>({
  possibleValues,
  selectedValueKey,
  setSelectedValue,
  label,
}: {
  label?: string;
  possibleValues: SchemaSelectionComponentItem<T>[];
  selectedValueKey: string | null;
  setSelectedValue: (key: string | null, value: T | null) => void;
}) => {
  const id = useId();
  const selectedValue = possibleValues.find(
    (value) => value.optionKey === selectedValueKey,
  );
  const sortedPossibleValues = useMemo(
    () =>
      [...possibleValues].sort((a, b) =>
        a.optionLabel.localeCompare(b.optionLabel),
      ),
    [possibleValues],
  );

  return (
    <select
      className="form-select"
      aria-label={label}
      id={id}
      value={selectedValue?.optionKey ?? 'N/A'}
      onChange={(e) => {
        if (e.target.value === 'N/A') {
          setSelectedValue(null, null);
          return;
        }
        const value = possibleValues.find(
          (value) => value.optionKey === e.target.value,
        );
        if (!value) {
          return;
        }
        setSelectedValue(value.optionKey, value.optionValue);
      }}
    >
      <option key={'N/A'} value={'N/A'}>
        {'N/A'}
      </option>
      {sortedPossibleValues.map((selection) => (
        <option key={selection.optionKey} value={selection.optionKey}>
          {selection.optionLabel}
        </option>
      ))}
    </select>
  );
};
